import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../../assets/css/datatables/datatables.min.css";
import "../../assets/css/datatables/responsive.dataTables.min.css";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import axios from "axios";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

class BankEMI extends Component{
    constructor(props) {
        super(props);
        this.state={
            table:{},
            monthID:'062019',
            user_id:'',
            loading: true,
            is_record: true
        }
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token)
        this.setState({
            user_id:decoded._id
        })
    }
    // callInstallationMethod() {
    //     //this._getAllMerchants();
    //     this.get_filtered_data('','',this.state.monthID )
    // }
    get_filtered_bank_emi(bid,month){
        if ($.fn.DataTable.isDataTable('#BankEMI')) {
            $('#BankEMI').DataTable().clear().destroy();
        }
        this.setState({
            loading: true,
            is_record: true
        });
        let tableHeaders=[];
        let tableBody = [];
        axios.post(config.get('API_URL')+'/invoice/bank_emi_rows/',{
            bid: bid,
            month: month
        },
            {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {
            console.log(response);
            console.log(response.data);
            if(Array.isArray(response.data.data) && response.data.data.length){
                //if (response.data.data != null) {
                const keys = Object.keys(response.data.data[0]);
                console.log(keys);
                keys.forEach(function (k) {
                    tableHeaders.push({
                        sTitle: k,
                        mData: k.replace(/\./g, '\\.')
                        //optionally do some type detection here for render function
                    });
                    tableBody.push({
                        data: k,
                    })
                });
                console.log(JSON.stringify(tableHeaders));
                console.log(JSON.stringify(tableBody));

                this.setState({
                    loading: false,
                    is_record: true
                });
                this.get_filtered_bank_emi_data(bid, month, tableHeaders, tableBody);
            } else {
                //alert("hi");
                if ($.fn.DataTable.isDataTable('#BankEMI')) {
                    $('#BankEMI').DataTable().clear().destroy();
                }

                this.setState({
                    is_record: false,
                    loading: false,
                });
            }
        })
    }

    get_filtered_bank_emi_data(bid,month,tableHeaders,tableBody){
        var bankEmiData = {
            bid: bid,
            month: month,
        }
        $('#BankEMI').html('');
        var bankTrTable = $('#BankEMI').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : true,
                "autoWidth": false,
                "responsive": true,
                "lengthMenu": [[20, 45, 50, -1], [20, 45, 50, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/invoice/bank_emi_rows_details",
                    type: "POST",
                    data: bankEmiData,
                    dataSrc:function ( json ) {
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                },
                aoColumns:tableHeaders,
                columns: tableBody,
            });
    }

    render() {
        return(
            <div className="row tansactionTabs">
                <div className="clearfix"></div>
                <BeatLoader
                    css={override}
                    sizeUnit={"px"}
                    size={20}
                    color={'#123abc'}
                    loading={this.state.loading}
                />
                {this.state.is_record ?
                    <div className="content-tdetails-table table-full-width table-responsive">

                        <table id="BankTerminal" className="table table-striped table-hover">

                        </table>
                    </div> :
                    <div className="empty_data"> No record Found</div>
                }
                <div className="footer">
                    <div className="stats"><i></i>
                    </div>
                </div>
            </div>
        );
    }

}

export default BankEMI